export const selectOnlineFreeUsers = state => {
  return state.online.items;
};
export const selectFiltersFreeUsers = state => {
  return state.online.filterItems;
};
export const selectFiltersPaginationFreeUsers = state => {
  return state.online.filterItemsPagination;
};
